import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

import { MappedUploadedPhotos } from "pages/VehicleAnalysis/types";

import { uniqueByHash } from "utils/atomsHelper/photosUpload";

import { additionalDocumentsAtom } from "./additionalDocuments";
import { damagePhotosAtom } from "./damagePhotos";
import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";
import { mileagePhotoAtom } from "./vehicleCondition/mileage";
import { vehiclePhotosAtom } from "./vehiclePhotos";

export const allPhotosToUploadAtom = atom((get) => {
  const additionalDocuments = get(additionalDocumentsAtom);
  const damagePhotos = get(damagePhotosAtom);
  const vehiclePhotos = get(vehiclePhotosAtom);
  const mileagePhotos = get(mileagePhotoAtom);
  const damageAndVehiclePhotos = [...damagePhotos, ...vehiclePhotos].filter(uniqueByHash);

  return [...damageAndVehiclePhotos, ...additionalDocuments, ...mileagePhotos];
});

const sessionUploadedPhotosAtom = atomFamily((sessionId: string) =>
  createPersistedAtom<MappedUploadedPhotos>(`uploadedPhotos-${sessionId}`, {})
);
export const uploadedPhotosAtom = createDerivedSessionAtom<MappedUploadedPhotos>(sessionUploadedPhotosAtom);

const sessionUploadCompleteAtom = atomFamily((sessionId: string) =>
  createPersistedAtom<boolean>(`photosUploadComplete-${sessionId}`, false)
);
export const photoUploadCompleteAtom = createDerivedSessionAtom<boolean>(sessionUploadCompleteAtom);

const sessionPhotosClassifiedAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`photosClassified-${sessionId}`, false)
);
export const photosClassifiedAtom = createDerivedSessionAtom<boolean>(sessionPhotosClassifiedAtom);

const sessionPhotosScanned = atomFamily((sessionId: string) =>
  createPersistedAtom(`photosScanned-${sessionId}`, false)
);
export const photosScannedAtom = createDerivedSessionAtom<boolean>(sessionPhotosScanned);
